<div class="bg-white w-full">
  <div class="flex justify-between w-full max-w-screen-xl mx-auto items-center">
    <!-- LOGO -->
    <button  class="w-[180px] h-[80px] object-cover cursor-pointer" (keydown.enter)="onClickHome()" (click)="onClickHome()">
      <div class="header-img" [innerHTML]="svgContent()"></div>
    </button>

    <!-- ICONA HAMBURGER (visibile solo su mobile) -->
    <button
      class="lg:hidden flex flex-col gap-1.5 mr-[1rem]"
      (click)="menuOpen = !menuOpen"
      aria-label="Menu"
    >
      <span
        class="block w-[2rem] h-[4px] bg-black transition-all duration-300"
        [class.rotate-45]="menuOpen"
        [class.translate-y-2]="menuOpen"
      ></span>
      <span
        class="block w-[2rem] h-[4px] bg-black transition-all duration-300"
        [class.opacity-0]="menuOpen"
      ></span>
      <span
        class="block w-[2rem] h-[4px] bg-black transition-all duration-300"
        [class.-rotate-45]="menuOpen"
        [class.-translate-y-2]="menuOpen"
      ></span>
    </button>

    <!-- MENU DESKTOP -->
    <div class="hidden lg:flex items-center gap-5">
      @if (!user()) {
      <app-buttons
        [label]="'header.who' | translate"
        (click)="goTo(ROUTES.ABOUT_US)"
        (keydown.enter)="goTo(ROUTES.ABOUT_US)"
      >
      </app-buttons> 
      <div class="flex gap-2">
        <app-buttons [label]="'header.candidate_access' | translate" (click)="goTo(ROUTES.CANDIDATE)" (keydown.enter)="goTo(ROUTES.CANDIDATE)">
        </app-buttons>
        <app-buttons
          [label]="'header.employer_access' | translate"
          (click)="goTo(ROUTES.EMPLOYER)"
          (keydown.enter)="goTo(ROUTES.EMPLOYER)"
          [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
        >
        </app-buttons>
      </div>
      } @else {
      <div class="flex gap-5">
        <app-buttons
          [label]="'header.home' | translate"
          [btnClass]="getBtnClassSelected(ROUTES.HOME)"
          (click)="onClickHome()"
          (keydown.enter)="onClickHome()"
        >
          <i class="pi pi-home"></i>
        </app-buttons>
        <app-buttons
          [label]="'header.dashboard' | translate"
          [btnClass]="getBtnClassSelected(ROUTES.DASHBOARD)"
          [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
          (click)="onClickDashboard()"
          (keydown.enter)="onClickDashboard()"
        >
          <i class="pi pi-objects-column"></i>
        </app-buttons>
        <app-buttons
          [label]="'header.message' | translate"
          [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
          [btnClass]="getBtnClassSelected(ROUTES.MESSAGES)"
          (click)="onClickMessages()"
          (keydown.enter)="onClickMessages()"
        >
          <i class="pi pi-envelope"></i>
        </app-buttons>
        <app-buttons
          [label]="'header.offerts' | translate"
          [btnClass]="getBtnClassSelected(ROUTES.YOURS_OPPORTUNITIES)"
          (click)="onYourAds()"
          (keydown.enter)="onYourAds()"
        >
          <i class="pi pi-list"></i>
        </app-buttons>
      </div>

      <div class="flex gap-[20px] items-center">
        <button
          class="rounded-full p-2 bg-brand-secondary text-white flex flex-col items-center justify-center w-[40px] h-[40px]"
          type="button"
          (click)="onAdd()"
          (kewdown.enter)="onAdd()"
        >
          <i class="pi pi-plus"></i>
        </button>
        <button
          class="rounded-full bg-white text-white flex flex-col items-center justify-center"
          type="button"
          (click)="onClickProfile()"
        >
          <img
            [src]="getProfileImageUrl()"
            width="40"
            height="40"
            class="w-[40px] h-[40px] max-w-unset rounded-full border-0"
            alt="Profile"
            (keydown.enter)="getProfileImageUrl()"
          />
        </button>
      </div>
      }
    </div>
  </div>

  <!-- MENU MOBILE (a comparsa con animazione) -->
  @if(menuOpen) {
  <div
    class="lg:hidden flex flex-col items-start gap-4 p-4 border-t border-gray-200 bg-white overflow-hidden transition-all duration-300 ease-in-out transform scale-y-0 origin-top"
    [class.scale-y-100]="menuOpen"
  >
    @if (!user()) {
    <app-buttons [label]="'header.who' | translate" (click)="goTo(ROUTES.ABOUT_US)" (keydown.enter)="goTo(ROUTES.ABOUT_US)">
    </app-buttons>
    <app-buttons [label]="'header.candidate_access' | translate" (click)="goTo(ROUTES.CANDIDATE)" (keydown.enter)="goTo(ROUTES.CANDIDATE)">
    </app-buttons>
    <app-buttons
      [label]="'header.employer_access' | translate"
      (click)="goTo(ROUTES.EMPLOYER)"
      [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
      (keydown.enter)="goTo(ROUTES.EMPLOYER)"
    >
    </app-buttons>
    } @else {
    <app-buttons
      [label]="'header.home' | translate"
      [btnClass]="BUTTON_CLASS_TYPES.PRIMARY"
      (click)="onClickHome()"
      (keydown.enter)="onClickHome()"
    >
      <i class="pi pi-home"></i>
    </app-buttons>
    <app-buttons [label]="'header.dashboard' | translate" [btnClass]="BUTTON_CLASS_TYPES.TERTIARY">
      <i class="pi pi-objects-column"></i>
    </app-buttons>
    <app-buttons
      [label]="'header.message' | translate"
      [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
      (click)="onClickMessages()"
      (keydown.enter)="onClickMessages()"
    >
      <i class="pi pi-envelope"></i>
    </app-buttons>
    <app-buttons
      [label]="'header.offerts' | translate"
      [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
      (click)="onYourAds()"
      (keydown.enter)="onYourAds()"
    >
      <i class="pi pi-list"></i>
    </app-buttons>
    }
  </div>

  }
</div>
